/**
 * API Configuration
 * Centralized configuration for API endpoints and base URLs
 */

// Base API URL - development'ta local API, diger ortamlarda production API
const DEV_API_BASE_URL = 'https://localhost:7000';
const PROD_API_BASE_URL = 'https://satinalmabe.masburo.com';

export const API_BASE_URL =
  process.env.NODE_ENV === 'development' ? DEV_API_BASE_URL : PROD_API_BASE_URL;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    REQUEST_OTP: '/api/Auth/request-otp',
    VERIFY_OTP: '/api/Auth/verify-otp',
  },
  
  // Item endpoints
  ITEM: {
    LIST: '/api/Item',
    DETAIL: '/api/Item',
    SEARCH: '/api/Item/search',
    ITEM_360: '/api/Item/360',
    QUOTE_REPORT: (id: number | string) => `/api/Item/${id}/quote-report`,
    WITH_PO_REQUESTS: '/api/Item/with-po-requests',
  },
  
  // Item Category endpoints
  ITEM_CATEGORY: {
    LIST: '/api/ItemCategory',
    DETAIL: '/api/ItemCategory',
    CREATE: '/api/ItemCategory',
    UPDATE: '/api/ItemCategory',
    DELETE: '/api/ItemCategory',
  },
  
  // PO Request endpoints
  PO_REQUEST: {
    LIST: '/api/PORequest',
    DETAIL: '/api/PORequest',
    CREATE: '/api/PORequest',
    UPDATE: '/api/PORequest',
    DELETE: '/api/PORequest',
    STATUS_COUNTS: '/api/PORequest/status-counts',
    DETAIL_FULL: (id: number | string) => `/api/PORequest/${id}/detail`,
  },
  
  // Quote endpoints
  QUOTE: {
    LIST: '/api/Quote',
    DETAIL: '/api/Quote',
    CREATE: '/api/Quote',
    UPDATE: '/api/Quote',
    DELETE: '/api/Quote',
    CLOSE: '/api/Quote',
    SEND_MAIL: '/api/Quote',
    FROM_PO_REQUESTS: '/api/Quote/from-po-requests',
    FROM_QUOTE_ITEMS: '/api/Quote/from-quote-items',
    ITEM_SET_AWARDED: '/api/Quote/item',
    ITEM_SET_REJECTED: '/api/Quote/item',
    ITEM_NEGOTIATE: '/api/Quote',
    ITEM_HISTORY: '/api/Quote/item',
    SET_CLOSED: '/api/Quote',
    SET_RESPONDED: '/api/Quote',
    SET_VIEWED: '/api/Quote',
    REVIEW_DETAIL: '/api/Quote/review',
  },
  
  // PO Request Quote endpoints
  PO_REQUEST_QUOTE: {
    QUOTE_ITEMS: '/api/PORequest',
    NEGOTIATION_SUPPLIERS: '/api/PORequest/negotiation-suppliers',
    AWARDED_SUPPLIERS: '/api/PORequest/awarded-suppliers',
    SUPPLIER_AWARDED_QUOTE_ITEMS: '/api/PORequest/supplier',
    SUPPLIER_NEGOTIATION_QUOTE_ITEMS: '/api/PORequest/supplier',
  },
  
  // Quote Public endpoints
  QUOTE_PUBLIC: {
    REVIEW_DETAIL: '/api/QuotePublic',
    REVIEW_ITEMS_UPDATE: '/api/QuotePublic',
    REVIEW_UPDATE: '/api/QuotePublic',
    SEND_CONFIRMATION: '/api/QuotePublic',
  },
  
  // Supplier endpoints
  SUPPLIER: {
    WITH_PURCHASE_INFO: '/api/Supplier/with-purchase-info',
  },

  // Dashboard endpoints
  DASHBOARD: {
    USER: '/api/dashboard/user',
    ADMIN: '/api/dashboard/admin',
    PURCHASER: '/api/dashboard/purchaser',
  },

  // ERP endpoints
  ERP: {
    ORDER_TRACKING: '/api/Erp/order-tracking',
  },
} as const;

// API Configuration object
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
} as const;

// Environment-specific configurations
export const getApiConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return {
    ...API_CONFIG,
    // Development-specific overrides
    ...(isDevelopment && {
      // Add any development-specific config here
    }),
  };
};

// Export default configuration
export default API_CONFIG;
